'use client';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import useWindowSize from '@repo/ui/src/components/shared/window-size';

const ContentLinks = (props) => {
  const { displayName, linkDisplay } = props;
  const linkObj = props ? buildLinkObj(props) : null;
  return (
    <div className="col-6 d-flex justify-content-center justify-content-lg-start clickable-item-container">
      <style>
        {`
        .clickable-item-container{
          text-decoration: ${linkDisplay === 'Text' ? 'underline' : 'none'};
          font-size: 1rem;
        }
        .font-color-white:hover{
          font-color: white !important;
          color: white !important;
        }
      `}
      </style>
      {linkObj && linkDisplay && displayName ? (
        <a
          rel={getRel(linkObj)}
          href={linkObj.href}
          className={`${linkDisplay === 'Button' ? 'font-color-white primary-button px-4' : ''}`}
        >
          {displayName}
        </a>
      ) : null}
    </div>
  );
};

const TwoThirdsGeneralContent = (props) => {
  const [width] = useWindowSize();
  const isLg = width > 992 && width < 1200;
  const isXL = width > 1199;
  const isMdOrSmaller = width < 993;
  const { image, cardTitle, title, description, links, linkDisplay } = props;
  const imgUrl = image
    ? buildImageSrc(
        image,
        isMdOrSmaller ? width : 1500,
        isXL ? 3 : isLg ? 2 : 4,
        isMdOrSmaller ? 1 : 2,
      )
    : null;
  return (
    <div
      className={`${isMdOrSmaller ? 'jumbotron rotating-background p-0 m-0' : 'container py-5'}`}
    >
      <div className={`${isMdOrSmaller ? '' : 'card'}`}>
        <div className={`${isMdOrSmaller ? 'd-flex flex-column' : 'row'}`}>
          {image ? (
            <div className={`${isMdOrSmaller ? 'd-flex justify-content-center' : 'col-md-8'}`}>
              <LazyLoadImage
                imgComponent={
                  <img className="tw-round-t tw-rounded-l" src={imgUrl} alt={cardTitle} />
                }
              />
            </div>
          ) : null}
          <div
            className={`${
              isMdOrSmaller
                ? 'card col-11 col-sm-10 mx-auto pt-2 pb-5 px-4 tw-relative tw-top-[-50px]'
                : 'col-12 col-md-4 p-4'
            }`}
          >
            {cardTitle ? (
              <>
                <h5 className="d-flex mx-auto align-items-lg-left pt-3">{cardTitle}</h5>
                <hr className="mx-auto mx-lg-0 float-lg-left short-hr" />
              </>
            ) : null}
            <br className={`${isMdOrSmaller ? 'mb-0' : ''}`} />
            {title ? <h2 className="text-center text-lg-left">{title}</h2> : null}
            {description ? (
              <p className="mx-auto mx-lg-0 float-lg-left pr-4">{description}</p>
            ) : null}
            {links ? (
              <div className="row d-flex justify-content-center justify-content-lg-start pt-2">
                {links.map((link, i) => (
                  <ContentLinks {...link} linkDisplay={linkDisplay} key={`content-link-${i}`} />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoThirdsGeneralContent;
